import { jsx } from "react/jsx-runtime";
import { Button, ButtonSize, ButtonPriority, HoverStyles } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useForcedState, ForcedState } from "../../../../../contexts/forced-state-context.js";
import { classes } from "./previous-button.st.css";
const PreviousButton = ({
  previousText,
  className,
  onClick
}) => {
  const forcedState = useForcedState();
  const hover = forcedState.includes(ForcedState.PREVIOUS_BUTTON_HOVER);
  return /* @__PURE__ */ jsx(
    Button,
    {
      className: classNames(
        classes.previousButton,
        {
          [classes.previousButtonHover]: hover
        },
        className
      ),
      hoverStyle: HoverStyles.underline,
      upgrade: true,
      wrapContent: true,
      priority: ButtonPriority.basicSecondary,
      size: ButtonSize.large,
      onClick,
      children: previousText
    }
  );
};
export {
  PreviousButton as default
};
//# sourceMappingURL=previous-button.js.map
